import * as React from 'react';
import { SVGProps } from 'react';

const SvgPills = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.933 18.374 18.146 7.971l9.94-2.663a5.385 5.385 0 0 1 2.787 10.404l-9.94 2.662Z"
    />
    <path
      fill="currentColor"
      d="M9.247 10.851a4.908 4.908 0 1 0 2.542 9.482l9.482-2.542-2.542-9.467-9.482 2.527Z"
    />
    <path
      fill="currentColor"
      d="M6.462 20.202a6.135 6.135 0 0 0 5.646 1.314l10.665-2.856-3.175-11.853L8.933 9.664a6.135 6.135 0 0 0-2.471 10.538Z"
    />
    <path
      fill={props.fill}
      d="M7 11.842 18.767 9 21 17.425 17.598 18 7 11.842Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m11.914 18.677 9.94 2.663-2.787 10.403-9.94-2.662a5.385 5.385 0 0 1 2.787-10.404Z"
    />
    <path
      fill="currentColor"
      d="M30.753 24.22a4.908 4.908 0 1 1-2.542 9.482l-9.482-2.542 2.542-9.482 9.482 2.542Z"
    />
    <path
      fill="currentColor"
      d="M29.492 35.096c-.54 0-1.079-.07-1.6-.211l-10.665-2.856 3.175-11.853 10.665 2.871a6.135 6.135 0 0 1-1.575 12.064v-.015ZM20.23 30.29l8.299 2.223a3.681 3.681 0 0 0 1.904-7.111L22.14 23.18l-1.91 7.111Z"
    />
  </svg>
);

export default SvgPills;
